import React, { FunctionComponent } from 'react';
import { Text, View, Image } from '@react-pdf/renderer';
import { STYLES } from '../constants';
import useHeaderProps from './useHeaderProps';

const Header: FunctionComponent = function () {
  const { tradesperson, customer, details, logo } = useHeaderProps();

  const TextTag = Text as unknown as FunctionComponent<any>;
  const ViewTag = View as unknown as FunctionComponent<any>;
  const ImageTag = Image as unknown as FunctionComponent<any>;

  return (
    <>
      <ViewTag style={STYLES.headerRow}>
        <ViewTag style={STYLES.headerHalfColumn}>
          {logo && (
            <ViewTag style={STYLES.logoContainer}>
              <ImageTag src={logo} style={STYLES.logo} />
            </ViewTag>
          )}
        </ViewTag>
        <ViewTag style={STYLES.headerHalfColumn}>
          <ViewTag style={STYLES.column}>
            <ViewTag style={{ ...STYLES.row, ...STYLES.mb4 }}>
              <ViewTag style={STYLES.headerDetailHeading}>
                <TextTag
                  style={{
                    ...STYLES['text-12-18-em'],
                    ...STYLES['text-neutral-500'],
                  }}
                >
                  From
                </TextTag>
              </ViewTag>
              <ViewTag style={STYLES.headerDetailColumn}>
                {tradesperson?.name && (
                  <TextTag
                    style={{
                      ...STYLES['text-12-18-em'],
                      ...STYLES['text-neutral-700'],
                    }}
                  >
                    {tradesperson.name}
                  </TextTag>
                )}
                {tradesperson?.addressLineOne && (
                  <TextTag
                    style={{
                      ...STYLES['text-12-18'],
                      ...STYLES['text-neutral-600'],
                    }}
                  >
                    {tradesperson.addressLineOne}
                  </TextTag>
                )}
                {tradesperson?.addressLineTwo ? (
                  <TextTag
                    style={{
                      ...STYLES['text-12-18'],
                      ...STYLES['text-neutral-600'],
                    }}
                  >
                    {tradesperson.addressLineTwo}
                  </TextTag>
                ) : null}
                {tradesperson?.postalCode && (
                  <TextTag
                    style={{
                      ...STYLES['text-12-18'],
                      ...STYLES['text-neutral-600'],
                    }}
                  >
                    {tradesperson.postalCode}
                  </TextTag>
                )}
                {tradesperson?.email && (
                  <TextTag
                    style={{
                      ...STYLES['text-12-18'],
                      ...STYLES['text-neutral-600'],
                    }}
                  >
                    {tradesperson.email}
                  </TextTag>
                )}
                {tradesperson?.phone && (
                  <TextTag
                    style={{
                      ...STYLES['text-12-18'],
                      ...STYLES['text-neutral-600'],
                    }}
                  >
                    {tradesperson.phone}
                  </TextTag>
                )}
              </ViewTag>
            </ViewTag>

            {tradesperson?.vatNumber && (
              <ViewTag style={{ ...STYLES.row, ...STYLES.mb4 }}>
                <ViewTag style={STYLES.headerDetailHeading}>
                  <TextTag
                    style={{
                      ...STYLES['text-12-18-em'],
                      ...STYLES['text-neutral-500'],
                    }}
                  >
                    VAT no.
                  </TextTag>
                </ViewTag>
                <ViewTag style={STYLES.headerDetailColumn}>
                  <TextTag
                    style={{
                      ...STYLES['text-12-18'],
                      ...STYLES['text-neutral-600'],
                    }}
                  >
                    {tradesperson.vatNumber}
                  </TextTag>
                </ViewTag>
              </ViewTag>
            )}

            {tradesperson?.accountName && (
              <ViewTag style={STYLES.row}>
                <ViewTag style={STYLES.headerDetailHeading}>
                  <TextTag
                    style={{
                      ...STYLES['text-12-18-em'],
                      ...STYLES['text-neutral-500'],
                    }}
                  >
                    Account name
                  </TextTag>
                </ViewTag>
                <ViewTag style={STYLES.headerDetailColumn}>
                  <TextTag
                    style={{
                      ...STYLES['text-12-18'],
                      ...STYLES['text-neutral-600'],
                    }}
                  >
                    {tradesperson.accountName}
                  </TextTag>
                </ViewTag>
              </ViewTag>
            )}

            {tradesperson?.accountNumber && (
              <ViewTag style={STYLES.row}>
                <ViewTag style={STYLES.headerDetailHeading}>
                  <TextTag
                    style={{
                      ...STYLES['text-12-18-em'],
                      ...STYLES['text-neutral-500'],
                    }}
                  >
                    Account no.
                  </TextTag>
                </ViewTag>
                <ViewTag style={STYLES.headerDetailColumn}>
                  <TextTag
                    style={{
                      ...STYLES['text-12-18'],
                      ...STYLES['text-neutral-600'],
                    }}
                  >
                    {tradesperson.accountNumber}
                  </TextTag>
                </ViewTag>
              </ViewTag>
            )}

            {tradesperson?.sortCode && (
              <ViewTag style={STYLES.row}>
                <ViewTag style={STYLES.headerDetailHeading}>
                  <TextTag
                    style={{
                      ...STYLES['text-12-18-em'],
                      ...STYLES['text-neutral-500'],
                    }}
                  >
                    Sort code
                  </TextTag>
                </ViewTag>
                <ViewTag style={STYLES.headerDetailColumn}>
                  <TextTag
                    style={{
                      ...STYLES['text-12-18'],
                      ...STYLES['text-neutral-600'],
                    }}
                  >
                    {tradesperson.sortCode}
                  </TextTag>
                </ViewTag>
              </ViewTag>
            )}
          </ViewTag>
        </ViewTag>
      </ViewTag>

      <ViewTag style={STYLES.detailsRow}>
        <ViewTag style={STYLES.headerHalfColumn}>
          <ViewTag style={STYLES.column}>
            <ViewTag style={STYLES.row}>
              <ViewTag style={STYLES.customerDetailHeading}>
                <TextTag
                  style={{
                    ...STYLES['text-12-18-em'],
                    ...STYLES['text-neutral-500'],
                  }}
                >
                  For
                </TextTag>
              </ViewTag>
              <ViewTag style={STYLES.customerDetailColumn}>
                {customer?.name && (
                  <TextTag
                    style={{
                      ...STYLES['text-12-18-em'],
                      ...STYLES['text-neutral-700'],
                    }}
                  >
                    {customer.name}
                  </TextTag>
                )}
                {customer?.addressLineOne && (
                  <TextTag
                    style={{
                      ...STYLES['text-12-18'],
                      ...STYLES['text-neutral-600'],
                    }}
                  >
                    {customer.addressLineOne}
                  </TextTag>
                )}
                {customer?.addressLineTwo && (
                  <TextTag
                    style={{
                      ...STYLES['text-12-18'],
                      ...STYLES['text-neutral-600'],
                    }}
                  >
                    {customer.addressLineTwo}
                  </TextTag>
                )}
                {customer?.postalCode && (
                  <TextTag
                    style={{
                      ...STYLES['text-12-18'],
                      ...STYLES['text-neutral-600'],
                    }}
                  >
                    {customer.postalCode}
                  </TextTag>
                )}
                {customer?.email && (
                  <TextTag
                    style={{
                      ...STYLES['text-12-18'],
                      ...STYLES['text-neutral-600'],
                    }}
                  >
                    {customer.email}
                  </TextTag>
                )}
                {customer?.phoneNumber && (
                  <TextTag
                    style={{
                      ...STYLES['text-12-18'],
                      ...STYLES['text-neutral-600'],
                    }}
                  >
                    {customer.phoneNumber}
                  </TextTag>
                )}
              </ViewTag>
            </ViewTag>
          </ViewTag>
        </ViewTag>
        <ViewTag style={STYLES.headerHalfColumn}>
          <ViewTag style={STYLES.column}>
            {details?.reference && (
              <ViewTag style={STYLES.row}>
                <ViewTag style={STYLES.headerDetailHeading}>
                  <TextTag
                    style={{
                      ...STYLES['text-12-18-em'],
                      ...STYLES['text-neutral-500'],
                    }}
                  >
                    Reference
                  </TextTag>
                </ViewTag>
                <ViewTag style={STYLES.headerDetailColumn}>
                  <TextTag
                    style={{
                      ...STYLES['text-11-18'],
                      ...STYLES['text-neutral-600'],
                    }}
                  >
                    {details.reference}
                  </TextTag>
                </ViewTag>
              </ViewTag>
            )}
            {details?.date && (
              <ViewTag style={STYLES.row}>
                <ViewTag style={STYLES.headerDetailHeading}>
                  <TextTag
                    style={{
                      ...STYLES['text-12-18-em'],
                      ...STYLES['text-neutral-500'],
                    }}
                  >
                    Date
                  </TextTag>
                </ViewTag>
                <ViewTag style={STYLES.headerDetailColumn}>
                  <TextTag
                    style={{
                      ...STYLES['text-12-18'],
                      ...STYLES['text-neutral-600'],
                    }}
                  >
                    {details.date}
                  </TextTag>
                </ViewTag>
              </ViewTag>
            )}
          </ViewTag>
        </ViewTag>
      </ViewTag>
    </>
  );
};

export default Header;
